// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3Zqnv","info":"UpdateTermsInfo_info__2cM1r"};